import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
   fetchAgency,
   fetchInviteAgent,
   patchAgency,
   uploadAgencyImage,
 } from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const AGENCY_FETCH_FAILURE = 'AGENCY_FETCH_FAILURE';
export const AGENCY_FETCH_REQUEST = 'AGENCY_FETCH_REQUEST';
export const AGENCY_FETCH_SUCCESS = 'AGENCY_FETCH_SUCCESS';
export const AGENT_INVITE_FAILURE = 'AGENT_INVITE_FAILURE';
export const AGENT_INVITE_REQUEST = 'AGENT_INVITE_REQUEST';
export const AGENT_INVITE_SUCCESS = 'AGENT_INVITE_SUCCESS';
export const AGENCY_EDIT_FAILURE = 'AGENCY_EDIT_FAILURE';
export const AGENCY_EDIT_REQUEST = 'AGENCY_EDIT_REQUEST';
export const AGENCY_EDIT_SUCCESS = 'AGENCY_EDIT_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------
export function requestingAgency() {
  return {
    type: AGENCY_FETCH_REQUEST,
    payload: null,
  };
}
export function requestAgencySuccess(json) {
  return {
    type: AGENCY_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function requestAgencyFailure(json) {
  return {
    type: AGENCY_FETCH_FAILURE,
    payload: json,
  };
}
export function agencyEditRequest() {
  return {
    type: AGENCY_EDIT_REQUEST,
  };
}
export function agencyEditSuccess(json) {
  return {
    type: AGENCY_EDIT_SUCCESS,
    payload: json,
  };
}
export function agencyEditFailure(json) {
  return {
    type: AGENCY_EDIT_FAILURE,
    payload: json,
  };
}
export function agentInviteRequest() {
  return {
    type: AGENT_INVITE_REQUEST,
  };
}
export function agentInviteSuccess(payload) {
  return {
    type: AGENT_INVITE_SUCCESS,
    payload,
  };
}
export function agentInviteFailure(id) {
  return {
    type: AGENT_INVITE_FAILURE,
    payload: id,
  };
}
export function requestAgency(payload) {
  return (dispatch) => {
    dispatch(requestingAgency());
    return fetchAgency(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestAgencySuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestAgencyFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
        Promise.resolve();
        // TODO: we need a promise here because of the tests, find a better way
      });
  };
}
export function sendAgentInvite(payload) {
  return (dispatch) => {
    dispatch(agentInviteRequest());
    fetchInviteAgent(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        console.log(response);
        const notificationOpts = {
          title: 'Inviting Agent',
          message: 'Getting ready to make booking travel a breeze.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(agentInviteSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Inviting Agent',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(agentInviteFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Inviting Agent',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(agentInviteFailure());
        }
      });
  };
}
export function editAgency(id, payload) {
  return (dispatch) => {
    dispatch(agencyEditRequest());
    patchAgency(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        console.log(response);
        const notificationOpts = {
          title: 'Edit Agency',
          message: 'Successfully updated agency.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(agencyEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Edit Agency',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(agencyEditFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Edit Agency',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(agencyEditFailure());
        }
      });
  };
}

export function editAgencyImage(id, payload) {
  return (dispatch) => {
    // dispatch(agencyEditRequest());
    uploadAgencyImage(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        console.log(response);
        const notificationOpts = {
          title: 'Edit Agency',
          message: 'Successfully updated agency.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(agencyEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Edit Agency',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(agencyEditFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Edit Agency',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(agencyEditFailure());
        }
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [AGENCY_FETCH_REQUEST]: state => update(
      state,
    {
      $set:
      {
        needFetch: false,
        isFetching: true,
        selectedAgency: {},
      },
    },
    ),
  [AGENCY_EDIT_SUCCESS]: (state, action) => {
    return update(
      state,
      {
        $set:
        {
          needFetch: false,
          isFetching: false,
          selectedAgency: action.payload,
        },
      },
    );
  },
  [AGENCY_FETCH_SUCCESS]: (state, action) => {
    if (action.payload.length !== 0) {
      return update(
        state,
        {
          $set:
          {
            needFetch: false,
            isFetching: false,
            selectedAgency: action.payload[0],
          },
        },
      );
    }
    return state;
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  agency: {
    id: null,
  },
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/agency/modules/agency.js